import * as React from 'react';
import {hot} from 'react-hot-loader';

import SlideShowPageWrapper from 'client/components/slideshow/SlideShowPageWrapper';

const Editor = () => <SlideShowPageWrapper />;

export default hot(module)(Editor);
